import React from 'react';
import logo from './logo.svg';
import './App.css';
import { Header } from './Header';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { MatchAnalysisPage } from './MatchAnalysisPage';
// import LeaguePage from './LeaguePage';
import { NotFoundPage } from './NotFoundPage';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import HomeTable from './HomeTable';
import BetGenerationPage from './BetGeneration';
import PredictionAccuracyChartsPage from './PredictionAccuracyCharts';
import { CookiePolicy } from './CookiePolicy';
import { PrivacyPolicy } from './PrivacyPolicy';
import { Terms } from './Terms';
import { SelectionProvider } from './SelectionContext';
import { SelectionOverlay } from './SelectionOverlay';

import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { useTranslation } from 'react-i18next';

const AppContent = () => {
  const location = useLocation();
  const isMatchAnalysisPage = location.pathname.includes('MatchAnalysis');
  const { t, i18n } = useTranslation();

  return (
    <div className={`App ${isMatchAnalysisPage ? 'match-analysis-route' : ''}`}>
      <Navbar />
      <main className="content-wrapper">
        <Routes>
          <Route path="" element={<HomeTable />} />
          <Route
            path="MatchAnalysis/:matchId"
            element={<MatchAnalysisPage />}
          />
          <Route path="BetGenerationPage" element={<BetGenerationPage />} />
          <Route
            path="PredictionAccuracyCharts"
            element={<PredictionAccuracyChartsPage />}
          />
          <Route path="cookie-policy" element={<CookiePolicy />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="terms" element={<Terms />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <SelectionOverlay />
      {!isMatchAnalysisPage && <Footer />}
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <SelectionProvider>
        <AppContent />
      </SelectionProvider>
    </BrowserRouter>
  );
}

class ProblemComponent extends React.Component {
  render() {
    return <div ref="div" />;
  }
}

export default App;
